import { css } from '@emotion/react';

import { COLORS } from '~/styles/colors';

export const useStyles = () => {
  return {
    icons: css`
      display: flex;
      justify-content: right;
      align-items: center;
      width: 100%;
      gap: 24px;
      margin-right: 24px;
    `,
    header: css`
      display: flex;
      align-items: center;
      width: 100%;
    `,
    wrapper: css`
      margin-bottom: 12px;
      border-radius: 16px;
      padding: 12px 16px;
      border: 1px solid ${COLORS.grey200};
      background-color: ${COLORS.lightGray};
    `,
    headerLeft: css`
      display: flex;
      gap: 8px;
      align-items: center;

      video,
      iframe {
        width: 42px;
        height: 42px;
        border-radius: 8px;
      }
    `,
  };
};
